// Contas da comanda e do fechamento de caixa. Ficam aqui para o servidor e o PDV
// calcularem exatamente igual (sempre em centavos inteiros).
import { FORMAS_PAGAMENTO, type FormaPagamento } from "./dominio";

export type ItemComPreco = { precoUnitCentavos: number; quantidade: number };

export function totalDosItens(itens: ItemComPreco[]): number {
  return itens.reduce((soma, i) => soma + i.precoUnitCentavos * i.quantidade, 0);
}

/** Troco a devolver, ou null se o valor recebido não cobre o total. */
export function calcularTroco(totalCentavos: number, recebidoCentavos: number): number | null {
  return recebidoCentavos >= totalCentavos ? recebidoCentavos - totalCentavos : null;
}

export type VendidoPorForma = Record<FormaPagamento, { quantidade: number; centavos: number }>;

export function vendidoZerado(): VendidoPorForma {
  return Object.fromEntries(FORMAS_PAGAMENTO.map((f) => [f, { quantidade: 0, centavos: 0 }])) as VendidoPorForma;
}

/** Quanto deve haver em cada forma: o vendido, e no dinheiro também o fundo de troco. */
export function esperadoPorForma(vendido: VendidoPorForma, fundoTrocoCentavos: number): Record<FormaPagamento, number> {
  return Object.fromEntries(
    FORMAS_PAGAMENTO.map((f) => [f, vendido[f].centavos + (f === "DINHEIRO" ? fundoTrocoCentavos : 0)]),
  ) as Record<FormaPagamento, number>;
}

export type LinhaFechamento = {
  formaPagamento: FormaPagamento;
  quantidadeVendas: number;
  vendidoCentavos: number;
  esperadoCentavos: number;
  contadoCentavos: number;
  /** contado − esperado: positivo é sobra, negativo é falta. */
  diferencaCentavos: number;
};

export function linhasDeFechamento(
  vendido: VendidoPorForma,
  fundoTrocoCentavos: number,
  contado: Record<FormaPagamento, number>,
): LinhaFechamento[] {
  const esperado = esperadoPorForma(vendido, fundoTrocoCentavos);
  return FORMAS_PAGAMENTO.map((f) => ({
    formaPagamento: f,
    quantidadeVendas: vendido[f].quantidade,
    vendidoCentavos: vendido[f].centavos,
    esperadoCentavos: esperado[f],
    contadoCentavos: contado[f],
    diferencaCentavos: contado[f] - esperado[f],
  }));
}
